import React, { useEffect, useState } from 'react'
import useApp from 'hooks/useApp'
import { Button, Input, LayerBottom } from 'components'
import carImg from 'images/tmp_car_image.png'
import styles from './index.module.css'

const Car = () => {

	const App = useApp()
	const [confirmLayer, setConfirmLayer] = useState(false)
	const [resultLayer, setResultLayer] = useState(false)

	const closeConfirm = () => {
		setConfirmLayer(false)
	}

	const showConfirm = () => {
		setConfirmLayer(true)
	}

	const closeResult = () => {
		setResultLayer(false)
	}

	const showResult = () => {
		setResultLayer(true)
	}


	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="flex_1">
				<div className="shadow">
					<div className="padding">
						<h2 className="text-blue">차량번호를 입력하세요.</h2>
						<p className="sub-guide mt_10">조회하고 싶은 차량 번호 입력 또는<br />최근 조회내역을 통해 차량 정보를 확인하세요.</p>
						<p className="guide-title mt_40">차량번호</p>
						<div className="form-group mt_10">
							<Input className="withBtn" type="text" id="" placeholder="ex.123가1234" />
							<Button className="btn btn--sm btn--light-blue floating" style={{ fontSize: "1.2rem" }} onClick={showResult}>검색</Button>
						</div>
						<div className="mt_20">* 무료조회 횟수 : 2회 / <span className="text-red">조회가능일 D-20</span></div>
					</div>
				</div>
				<div>
					<h3 className="padding">최근 조회</h3>

					{/* 데이터 있을 때 */}
					<div className="slider">
						<div className="no-scroll" style={{ overflowX: "auto" }}>
							<ul className={`${styles["car-search-list"]}`}>
								<li>
									<span className={styles.date}>2019.01.01</span>
									<div className="img-box mt_10">
										<img src={carImg} alt="" />
									</div>
									<p className={`${styles["car-num"]} mt_10`}>12가2445</p>
									<span className={`${styles.model} mt_5`}>테슬라 모델X</span>
									<div className={`${styles.price} mt_20`}><strong className="text-blue">13,800</strong> 만원</div>
								</li>
								<li>
									<span className={styles.date}>2019.01.01</span>
									<div className="img-box mt_10">
										<img src={carImg} alt="" />
									</div>
									<p className={`${styles["car-num"]} mt_10`}>12가2445</p>
									<span className={`${styles.model} mt_5`}>테슬라 모델X</span>
									<div className={`${styles.price} mt_20`}><strong className="text-blue">13,800</strong> 만원</div>
								</li>
							</ul>
						</div>
						<ul className="slider-dots dots-gray mt_20" style={{ position: "absolute", right: "2rem", top: "-6rem" }}>
							<li className="active" />
							<li />
							<li />
						</ul>
					</div>

					{/* 데이터 없을 때 */}
					<div className="center-cont py_50">
						<i className="icon icon_no_data" />
						<p className="mt_20">최근 조회한 차량이 없어요</p>
					</div>
				</div>
			</div>
			<div className="padding flex-shrink_0">
				<Button className="btn btn--big">내 차 보기</Button>
			</div>

			<ConfirmLayer show={confirmLayer} closeConfirm={closeConfirm} closeButton={false} />
			<ResultLayer show={resultLayer} closeConfirm={closeResult} closeButton={false} />
		</div>
	)
}

const ConfirmLayer = ({ show, closeConfirm }) => {
	const [errorOpen, setErrorOpen] = useState(false)

	const OpenError = () => {
		setErrorOpen(!errorOpen)
	}
	return (
		<LayerBottom show={show} closeButton={false} closeConfirm={closeConfirm} outside={
			<Button className="btn btn--big btn-layer" onClick={() => closeConfirm()}>확인</Button>
		}>
			<div className="layer-text py_10">
				입력하신 정보는 이미 내차로 등록되어 있네요.<br />
				내 차 보기 페이지로 이동합니다.
				<p style={{ fontSize: "1.6rem", fontWeight: 500 }}>차량 조회에 실패하였습니다.</p>
				<div className={`error-code mt_20 ${errorOpen ? "active" : ""}`} onClick={OpenError}>
					<span className="flex-align_center text-red">오류코드 100052<i className="icon icon_error_arrow ml_10" /></span>
					<div className="mt_10">조회된 차량 없음</div>
				</div>
			</div>
		</LayerBottom>
	)
}

const ResultLayer = ({ show, closeConfirm }) => {
	return (
		<LayerBottom show={show} closeButton={false} closeConfirm={closeConfirm} outside={
			<Button className="btn btn--big btn-layer" onClick={() => closeConfirm()}>확인</Button>
		}>
			<div className="layer-text">
				‘회원명’님의 차량을 조회하셨네요.<br />
				본인 소유의 차량은 ‘내차보기’를 통해 등록이 가능해요. 확인을 누르시면 ‘내차보기’페이지 이동 후 나머지 등록 절차를 진행할 수 있게 안내해드릴께요.
			</div>
		</LayerBottom>
	)
}

// const TermsLayer = ({ show, closeTerms }) => {
// 	return (
// 		<LayerBottom title="차량 조회 및 등록을 위해 약관 동의해주세요." show={show} closeTerms={closeTerms} outside={
// 			<Button className="btn btn--big btn-layer" onClick={closeTerms} disabled>모두 동의하고 시작</Button>
// 		}>
// 			<ul className="terms-list">
// 				<li>
// 					<div className="chk">
// 						<input type="checkbox" id="check1" name="state" />
// 						<label htmlFor="check1">
// 							<span><strong>[필수]</strong> 개인정보 수집∙이용 동의</span>
// 						</label>
// 					</div>
// 				</li>
// 				<li>
// 					<div className="chk">
// 						<input type="checkbox" id="check2" name="state" />
// 						<label htmlFor="check2">
// 							<span><strong>[필수]</strong> 개인정보 제3자 제공 동의</span>
// 						</label>
// 					</div>
// 				</li>
// 			</ul>
// 		</LayerBottom>
// 	)
// }

export default Car
